import { cx } from '@emotion/css';
import { IconLookup, IconName } from '@fortawesome/fontawesome-svg-core';

import { Icon } from 'apps/shared/scripts/components';

import {
  cardItemTagClassName,
  errorClassName,
  iconClassName,
  infoClassName,
  labelClassName,
  statusIconClassName,
  successClassName,
} from './styles';

export enum TagStatus {
  Info = 'Info',
  Success = 'Success',
  Error = 'Error',
}

interface Props {
  faIcon: IconLookup | IconName;
  label?: string;
  status?: TagStatus;
  iconAfter?: boolean;
}

const CardItemTag = ({ faIcon, label, status, iconAfter = false }: Props) => {
  return (
    <div className={cardItemTagClassName}>
      {!iconAfter && (
        <Icon
          className={cx(iconClassName, {
            [statusIconClassName]: !!status,
            [infoClassName]: status === TagStatus.Info,
            [successClassName]: status === TagStatus.Success,
            [errorClassName]: status === TagStatus.Error,
          })}
          fa={faIcon}
        />
      )}
      {label && <span className={labelClassName}>{label}</span>}
      {iconAfter && (
        <Icon
          className={cx(iconClassName, {
            [statusIconClassName]: !!status,
            [infoClassName]: status === TagStatus.Info,
            [successClassName]: status === TagStatus.Success,
            [errorClassName]: status === TagStatus.Error,
          })}
          fa={faIcon}
        />
      )}
    </div>
  );
};

CardItemTag.displayName = 'CardItemTag';

export default CardItemTag;
